<template>
  <div v-if="payload">
    <Filterable :items="items" :payload="payload" v-if="payload.fullView" />
    <Simple :items="items" :payload="payload" v-else />
  </div>
</template>

<script>
import Filterable from "./index/Filterable";
import Simple from "./index/Simple";

export default {
  components: {
    Filterable,
    Simple
  },
  props: {
    payload: {
      default: () => {}
    },
    items: {
      default: () => []
    }
  }
};
</script>